export default "__VITE_ASSET__DMI9KCt___"